<template>
  <H5Orders v-if="isMobile === 'MOBILE'" />
  <PCOrders v-if="isMobile === 'PC'" />
</template>

<script setup>
import H5Orders from './H5Orders/index.vue'
import PCOrders from './PCOrders/index.vue'

const isMobile = ref('')
onBeforeMount(() => {
  const userAgent = navigator.userAgent.toLowerCase()
  isMobile.value = /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
})
</script>
